import React from 'react'
import Icon from 'material-ui/Icon'
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import Divider from 'material-ui/Divider'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'

import styles from '../styles'
import { Radio } from "material-ui";
import { FormControl, FormControlLabel, FormLabel } from "material-ui/Form";
import { RadioGroup } from "material-ui/Radio";
import { isSignalTEKQTType, isNaviTEKType } from "../../../common/utils"

const Context = (props) => {

  const {
    columns,
    columnPreset,
    applyPreset,
    toggleColumns,
    translate,
    job,
    isSignaltek10g,
    isMobile
  } = props

  let isSignalTEKQT = job && isSignalTEKQTType(job.deviceid);
  let isNaviTEK = job && isNaviTEKType(job.deviceid);

  const handleChange = (event) => {
    applyPreset(event.target.value);
  };

  return (
    <div>
      <Typography type="title">
        {translate("context_header_choose_column")}
      </Typography>
      <Typography>
        {translate("context_subheader_add_remove")}
      </Typography>
      <hr />

      <FormControl style={{ width: "460px" }}>
        <FormLabel id="demo-row-radio-buttons-group-label">Saved Presets</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={columnPreset}
          onChange={handleChange}
          style={{ padding: ".4em 1em", textAlign: "center", display: "flex", justifyContent: "center" }}
        >
          <FormControlLabel value="LanTEKIV" control={<Radio disabled={true} />} label="LanTEK IV" />
          <FormControlLabel value="LanTEKIII" control={<Radio disabled={true} />} label="LanTEK III" />
          <FormControlLabel value="SignalTEK10G" control={<Radio disabled={true} />} label="SignalTEK 10G" />
          <FormControlLabel value="SignalTEKQT" control={<Radio disabled={true} />} label="SignalTEK QT / SignalTEK QT Pro" />
          <FormControlLabel value="NaviTEK" control={<Radio disabled={true} />} label="NaviTEK / NaviTEK Pro" />
          <FormControlLabel value="VDVII_PoEPro" control={<Radio disabled={true} />} label="VDV II / PoE Pro" />
        </RadioGroup>
      </FormControl>

      <List dense>
        {
          columns.map((column, index) => {
            const allowedMobileColumns = [
              "nvp",
              "result_teststatus",
              "result_testdate",
              "result_tester",
              "result_neserialnumber",
              "result_length",
              "mobiletest_mode",
              "mobiletest_linkpulse",
              "mobiletest_poeclass",
              "mobiletest_onloadvoltageinvolts",
              "mobiletest_offloadvoltageinvolts",
              "mobiletest_poepowerinwatts",
              "mobiletest_cableinformation",
              "mobiletest_operatorname",
              "mobiletest_systemdevicetype"
            ];

            if (!isMobile && column.id.startsWith("mobiletest_")) {
              return null
            }

            if (isMobile && !allowedMobileColumns.includes(column.id)) {
              return null
            } //else if (!isMobile && allowedMobileColumns.includes(column.id)){
              //return null
            //} 
            else if (!isSignaltek10g) {
              if (["result_testtime", "result_cablename", "result_standard", "name", "result_teststatus", "result_cdnextworst", "result_cdnextmargin", "result_cmrlworst", "result_cmrlmargin", "", "move"].includes(column.id)) {
                return null
              }
            } else {
              let signaltek10gColumns = ["nvp", "result_testdate", "result_length", "result_delayskew", "result_propagationdelay", "result_organisation",
              "result_customer", "result_tester", "result_neserialnumber", "result_technician", "result_usernotes", "result_firmware", "result_standard",
              "result_network", "result_transmission", "result_wiremap", "result_poeload", "result_fiber", "result_createdat", "testinterface", "id", "createdat"];
              if (isSignalTEKQT || isNaviTEK) {
                signaltek10gColumns = signaltek10gColumns.filter(x => x != "result_transmission");
              }
              if (!signaltek10gColumns.includes(column.id)) {
                return null
              }
            }

            if (column.display)
              return (
                <div key={index}>
                  <ListItem
                    button
                    onClick={() => {
                      if (column.id === "name")
                        return
                      column.show = !column.show
                      toggleColumns(column)
                    }}>
                    <ListItemIcon>
                      {
                        (column.show) ? (
                          <Icon>remove</Icon>
                        ) : (
                            <Icon>add</Icon>
                          )
                      }
                    </ListItemIcon>
                    <ListItemText primary={column.Header} />
                  </ListItem>
                  <Divider />
                </div>
              )
            else {
              return null
            }
          })
        }
      </List>
    </div>
  )
}

export default withStyles(styles)(Context)



// WEBPACK FOOTER //
// ./src/components/job/context/index.js